/**
 * Original work Copyright (c) 2019 Burst Apps Team
 */

/**
 * Constants for payment subtypes
 *
 * @module core
 */
export enum TransactionPaymentSubtype {
    Ordinary = 0,
    MultiOut,
    MultiOutSameAmount,
}

